import React from 'react'
import PropTypes from 'prop-types'

export default function SplitLayout({ brand, children }) {
  return (
    <div className="container-image">
      {brand}
      <div className="container-login">
        <div className="login">{children}</div>
      </div>
    </div>
  )
}

SplitLayout.propTypes = {
  brand: PropTypes.node,
  children: PropTypes.node
}
